import FormPIIPopup from './popup';

const FormPIIModal = ({ isShow }) => {
  return (
    <FormPIIPopup
      isOpen={isShow}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1066}
      zIndexModal={1067}
    />
  );
};

export default FormPIIModal;
